var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { User } from '../Users/Model';
var Invoice = /** @class */ (function () {
    /*payment: Payment[]
    taxes: InvoiceTax[]*/
    function Invoice(props) {
        this.lines = []; // relación
        Object.assign(this, props);
        this.date = new Date(props.date);
    }
    return Invoice;
}());
export { Invoice };
var InvoiceLine = /** @class */ (function () {
    function InvoiceLine(props) {
        Object.assign(this, props);
    }
    return InvoiceLine;
}());
export { InvoiceLine };
var CashDesk = /** @class */ (function () {
    function CashDesk(props) {
        Object.assign(this, props);
        this.date = new Date(props.date);
    }
    return CashDesk;
}());
export { CashDesk };
export var CashDeskState = {
    open: 'open',
    close: 'close',
    partialClose: 'partialClose'
};
export var TypeAllocation = {
    Web: 'web',
    Gateway: 'pasarela',
    Collaborador: 'collaborador',
    Operator: 'operator'
};
var Ticket = /** @class */ (function () {
    function Ticket(props) {
        this.contact = {
            name: '',
            surname: '',
            telephone: '',
            pickUpLocations: '',
            dropOffLocations: '',
            flightInfo: '',
            email: '',
            additionalInformation: ''
        };
        Object.assign(this, props);
        var user = new User(props.user);
        this.user = user;
        this.username = props.username ? props.username : user.username;
        // this.businessUnit = props.operationLine? props.operationLine.businessUnit.name : props.businessUnitName
        this.tin = props.tin ? props.tin : props.operationLine.businessUnit.tin;
        this.image = props.image
            ? props.image
            : props.operationLine
                ? props.operationLine.businessUnit.image
                : undefined;
        // this.operationLine = props.operationLineName !== undefined? props.operationLineName : props.operationLine.name// new OperationLine(props.operationLine)
        // this.stretch = props.stretchName !== undefined? props.stretchName : props.stretch.name // new Stretch(props.stretch)
        this.operationLineName =
            props.operationLineName !== undefined
                ? props.operationLineName
                : props.operationLine.name;
        this.stretchName =
            props.stretchName !== undefined ? props.stretchName : props.stretch.name;
        this.datecheck = new Date(props.datecheck);
        this.datebook = props.datebook ? new Date(props.datebook) : null;
        this.datebookNTZ = props.datebookNTZ ? new Date(props.datebookNTZ) : null;
        this.datevalited = props.datevalited ? new Date(props.datevalited) : null;
        this.daterefund = props.daterefund ? new Date(props.daterefund) : null;
        if (props.lines) {
            if (typeof props.lines !== 'string') {
                this.lines = props.lines.map(function (line) { return new TicketLine(line); });
            }
            else {
                this.lines = JSON.parse(props.lines).map(function (line) { return new TicketLine(line); });
            }
        }
        if (!props.horasVuelta)
            this.horasVuelta = [];
        if (props.payments)
            this.payments = props.payments.map(function (payment) { return new Payment(payment); });
        if (props.ticketRefunded)
            this.ticketRefunded = new Ticket(props.ticketRefunded);
    }
    return Ticket;
}());
export { Ticket };
var TicketLine = /** @class */ (function () {
    function TicketLine(values) {
        Object.assign(this, values);
        // this.total = (values.price * values.quantity) + ((values.price * values.quantity) * values.tax / 100)
        // console.log('TicketLine - this', this)
    }
    return TicketLine;
}());
export { TicketLine };
var TicketExtraLine = /** @class */ (function () {
    function TicketExtraLine(values) {
        this.printDescription = true;
        Object.assign(this, values);
    }
    return TicketExtraLine;
}());
export { TicketExtraLine };
var CollaboratorTicket = /** @class */ (function (_super) {
    __extends(CollaboratorTicket, _super);
    function CollaboratorTicket(props) {
        var _this = _super.call(this, props) || this;
        _this.client_id = props.client_id;
        _this.operatorName = props.operatorName;
        _this.operator_id = props.operator_id;
        _this.collaboratorName = props.collaboratorName;
        _this.collaborator_id = props.collaborator_id;
        _this.belongCollaboratorPacket = props.belongCollaboratorPacket;
        return _this;
    }
    return CollaboratorTicket;
}(Ticket));
export { CollaboratorTicket };
var TicketCashDesk = /** @class */ (function () {
    function TicketCashDesk(values) {
        Object.assign(this, values);
        this.dateOpen = new Date(values.dateOpen);
        this.dateClose = new Date(values.dateClose);
    }
    return TicketCashDesk;
}());
export { TicketCashDesk };
var TicketCashDeskLine = /** @class */ (function () {
    function TicketCashDeskLine(values) {
        Object.assign(this, values);
    }
    return TicketCashDeskLine;
}());
export { TicketCashDeskLine };
var BasePacketTicket = /** @class */ (function () {
    function BasePacketTicket(props) {
        this.hasCollaboratorStretch = false;
        this.collaboratorTickets = [];
        Object.assign(this, props);
        this.datecheck = new Date(props.datecheck);
        this.daterefund =
            props.daterefund === null ? null : new Date(props.daterefund);
        if (props.tickets) {
            this.tickets = props.tickets.map(function (ticket) { return new Ticket(ticket); });
        }
        if (props.collaboratorTickets) {
            this.collaboratorTickets = props.collaboratorTickets;
        }
    }
    return BasePacketTicket;
}());
export { BasePacketTicket };
var PacketTicket = /** @class */ (function (_super) {
    __extends(PacketTicket, _super);
    function PacketTicket(props) {
        var _this = _super.call(this, props) || this;
        _this.printPrice = true;
        Object.assign(_this, props);
        /*this.image = props.operationLine.businessUnit.image*/
        if (!props.operationLineName && props.operationLine) {
            _this.operationLine =
                props.operationLineName !== undefined
                    ? props.operationLineName
                    : props.operationLine.name; // new OperationLine(props.operationLine)
        }
        if (props.datecheck) {
            _this.datecheck = new Date(props.datecheck);
        }
        if (props.datebook) {
            _this.datebook = new Date(props.datebook);
        }
        return _this;
        /*this.stretch = props.stretchName !== undefined? props.stretchName : props.stretch.name*/ // new Stretch(props.stretch)
        // this.datebook = props.datebook? new Date(props.datebook): null
    }
    return PacketTicket;
}(BasePacketTicket));
export { PacketTicket };
var Payment = /** @class */ (function () {
    function Payment(values) {
        Object.assign(this, values);
    }
    return Payment;
}());
export { Payment };
export var PaymentMethod = {
    Due: 'due',
    Cash: 'cash',
    Card: 'card',
    Credit: 'credit',
    Transfer: 'transfer',
    Other: 'other',
    Mixed: 'mixed'
};
export var getAfiliateFromSale = function (sale) {
    var _a;
    if (sale === null || sale === void 0 ? void 0 : sale.afiliate_id) {
        return {
            afiliate_id: sale.afiliate_id,
            afiliateName: sale.afiliateName,
        };
    }
    var afiliate = (_a = sale.payments) === null || _a === void 0 ? void 0 : _a.reduce(function (old, payment) {
        if (payment.method === PaymentMethod.Credit && payment.afiliate_id) {
            return {
                afiliate_id: payment.afiliate_id,
                afiliateName: payment.afiliateName
            };
        }
        return old;
    }, null);
    return afiliate;
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/Model.ts
// module id = 36
// module chunks = 0